/// <amd-module name="SuiteCommerce.Blog.Pagination.Button.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.Button.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Common.ParameterProcessor", "SuiteCommerce.Blog.Common"], function (require, exports, Backbone_1, ParameterProcessor_1, Common_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PaginationButtonModel = /** @class */ (function (_super) {
        __extends(PaginationButtonModel, _super);
        function PaginationButtonModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(PaginationButtonModel.prototype, "pageNumber", {
            get: function () {
                return this.get('pageNumber');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationButtonModel.prototype, "url", {
            get: function () {
                var urlComponents = ParameterProcessor_1.ParameterProcessor.decodeParams(Backbone_1.history.getFragment());
                var pageURLComponent = ParameterProcessor_1.PageSettings.page;
                if (urlComponents.queryParams || urlComponents.params) {
                    if (urlComponents.queryParams.indexOf(pageURLComponent + "=") !== -1) {
                        urlComponents.queryParams = urlComponents.queryParams.replace(new RegExp(pageURLComponent + "=[0-9]+", 'gi'), pageURLComponent + "=" + this.pageNumber);
                    }
                    else {
                        urlComponents.queryParams = urlComponents.queryParams
                            ? urlComponents.queryParams + "&" + pageURLComponent + "=" + this.pageNumber
                            : pageURLComponent + "=" + this.pageNumber;
                    }
                    return encodeURI("" + Common_1.BLOG_URL_BASE + (urlComponents.params ? "/" + urlComponents.params : '') + "?" + urlComponents.queryParams);
                }
                return encodeURI(Common_1.BLOG_URL_BASE + "?" + pageURLComponent + "=" + this.pageNumber);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationButtonModel.prototype, "isActive", {
            get: function () {
                return this.get('isActive');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationButtonModel.prototype, "label", {
            get: function () {
                return this.get('label') || this.pageNumber;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationButtonModel.prototype, "hideDivider", {
            get: function () {
                return this.get('hideDivider');
            },
            set: function (hideDivider) {
                this.set('hideDivider', hideDivider);
            },
            enumerable: true,
            configurable: true
        });
        return PaginationButtonModel;
    }(Backbone_1.Model));
    exports.PaginationButtonModel = PaginationButtonModel;
});
